import * as React from 'react';
import Col from 'antd/lib/grid/col';
import Divider from 'antd/lib/divider';
import Row from 'antd/lib/grid/row';
import Title from 'antd/lib/typography/Title';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { IntegrationType } from '../../types';
import { antGrey } from '../styles/globalStyles';

interface SectionHeaderProps {
    header: React.ReactNode;
    relatedIntegrations: IntegrationType[];
}

const SectionHeader: React.FC<SectionHeaderProps> = (props: SectionHeaderProps) => {
    const { header, relatedIntegrations } = props;
    const [integrationIcons, setIntegrationIcons] = React.useState([]);

    React.useEffect(() => {
        relatedIntegrations.forEach((integration) => {
            setIntegrationIcons((integrationIcons) => [...integrationIcons, iconAndAltForIntegrationType(integration)]);
        });
    }, []);

    return (
        <>
            <Row>
                <Col span={24}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Title
                            style={{ fontSize: '16px', fontWeight: 'normal', color: antGrey.grey8, marginBottom: '0' }}
                        >
                            {header}
                        </Title>
                        <div style={{ display: 'flex', gap: '18px' }}>
                            {integrationIcons.length > 0 &&
                                integrationIcons.map((icon, idx) => (
                                    <img key={idx} src={icon[0]} alt={icon[1]} width={20} height={20} />
                                ))}
                        </div>
                    </div>
                    <Divider style={{ minWidth: 'auto', margin: '20px 0px' }} />
                </Col>
            </Row>
        </>
    );
};

export default SectionHeader;
